export enum SearchState {
    Failed = "failed",
    Fetching = "fetching",
    None = "none",
    Success = "success"
}
